
const updateExistingBooking = async ( firebase, uid, cartData, locations, dateTimes, values ) => {

  try {
    const { jobReferenceNumber, crewSize, notes = '', roleProductionCompany, status = 'pending' } = values

    const booking_data = {}
    if ( status === 'pending' ) {
      booking_data.jobReferenceNumber = jobReferenceNumber
      booking_data.roleProductionCompany = roleProductionCompany
      booking_data.crewSize = crewSize
      booking_data.notes = notes
      booking_data.services = [ ...cartData ]
      booking_data.locations = locations
      booking_data.dateTimes = dateTimes
      booking_data.createdAt = new Date()
      booking_data.updatedAt = new Date()
      booking_data.user = uid
    }
    booking_data.status = status

    const booking = await firebase
      .firestore()
      .collection( "bookings" )
      .doc( values.id )
      .get()


    const newBooking = { ...booking.data().booking, ...booking_data }
    console.log( { newBooking } )
    await firebase
      .firestore()
      .collection( "bookings" )
      .doc( values.id )
      .update( { ...newBooking } )

    if ( booking ) return booking_data
    return null
  }
  catch ( error ) {
    console.error( 'update existing booking', { error: error.message } )
  }
}

export const UpdateExistingBooking = async ( firebase, values, cartData, locations, dateTimes, user, authUser ) => {
  try {
    if ( !authUser ) return { status: 404, error: { message: 'User not found' } }

    const booking = await updateExistingBooking( firebase, authUser.uid, cartData, locations, dateTimes, values )

    return {
      status: 200,
      booking,
      user,
    }

  } catch ( error ) {
    console.error( 'sign-up', { error: error.message } )
    return {
      status: 500,
      error
    }
  }
}

export default UpdateExistingBooking